import request from '../../utils/request';
const querystring = require('querystring')
//获取列表数据
export const fetchData = query => {
    query.type='2';
    var list = request({
        url: 'comState/selectPage.do',
        method: 'post',
        params: query
    }); 
    return list;
};

export const fetchDataAll = query => {
    query.type='2';
    var list = request({
        url: 'comState/selectPageAll.do',
        method: 'post',
        params: query
    });
    return list;
};
export const fetchData2 = query => {
     
    var list = request({
        url: 'haoka/hkWo/selectPage.do',
        method: 'post',
        params: query
    }); 
    return list;
};
export const saveForm = query => {
    query.type='2';
    query.fb1='1';
    var list = request({
        url: 'comState/insert.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

export const tsShibie = query => {
    query.channelCode='46';
    var list = request({
        url: 'comState/getDataByLink.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
export const saveEdit = query => {
    query.type='2';
    query.fb1='1';
    var list = request({
        url: 'comState/update.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const updateHandle = query => {
    query.type='2';
    query.fb1='1';
    var list = request({
        url: 'comState/updateHandle.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const getTsDetail = query => {
    query.type='2';
    query.fb1='1';
    var list = request({
        url: 'common/getTsDetail.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
export const getWorkOrderShow = query => {
    query.type='2';
    var list = request({
        url: 'comState/getDataShow2.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const getWorkDataShow = query => {
    query.type='2';
    var list = request({
        url: 'comState/getDataShow.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const downTsExcel = query => {
    var list = request({
        url: 'comState/getTsExcel.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const downTsMoreExcel = query => {
    var list = request({
        url: 'comState/getTsMoreExcel.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
export const getWorkOrderShow2 = query => {
    query.type='2';
    var list = request({
        url: 'comState/getDataMemShow2.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};


export const getStateDetail = query => {
    query.type='2';
    query.fb1='1';
    var list = request({
        url: 'comStateDetail/getList.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
//关闭订单
export const handDelete = query => {
    var list = request({
        url: 'comState/delete.do',
        method: 'post',
        params: query
    }); 
    return list;
};
//查询回复记录 
export const getReplayList = query => {
    query.my = '1';
    var list = request({
        url: 'haoka/hkWoReply/selectList.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

//回复
export const replyForm = query => {
    var list = request({
        url: 'haoka/hkWoReply/insert.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};





